/* eslint-disable react-hooks/exhaustive-deps */
import { StoreKey } from "@common/constans";
import { StorageType } from "@common/enum";
import { IBanner } from "@common/models/CMS";
import { getFilePath, IViewport } from "@config/appConfig";
import { AppAction, IAppAction } from "@misc/Action";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import Storage from "@service/Storage";
import { FC, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Divider from "../general/Divider";
import Button from "../general/form/Button";
import { IFormControlProps } from "../general/form/Form";
import Icon from "../general/Icon";
import { renderSourceBaseOfDevice } from "@components/Widgets/VideoWidget";
import { useHistory } from "react-router";

interface ITopSideBannerProps extends IFormControlProps {
    dataSource: IBanner[]
}

const TopSideBanner: FC<ITopSideBannerProps> = ({ dataSource, id }) => {
    const { banners } = useSelector((state: IAppState) => ({ banners: state.banners }));
    const { small } = Config.get<IViewport>("viewport");
    const { width } = useSelector((state: IAppState) => ({ width: state.windowWidth, banners: state.banners }));
    const dispatch = useDispatch();
    const { push } = useHistory();

    const topSideBannerItems = dataSource.map((banner, index) => {

        const onCloseButtonClick = (id: string) => {
            // Push banner item with current content id to excluded banners in local storage
            const excludedBanners: IBanner[] = Storage.get(StoreKey.ExcludedBanners, StorageType.Session) || [];
            const foundedBanner = banners.find(x => x.contentItemId === id);
            if (foundedBanner && !excludedBanners.find(x => x.contentItemId === foundedBanner.contentItemId))
                excludedBanners.push({ contentItemId: foundedBanner.contentItemId });
            Storage.set(StoreKey.ExcludedBanners, excludedBanners, StorageType.Session);
            // Update banners with filter banner items without banner item by current id
            dispatch<IAppAction>({ type: AppAction.Banners, payload: { banners: banners.filter(x => x.contentItemId !== id) } })
        }

        return (
            <Fragment key={index}>
                <div
                    id={banner.contentItemId}
                    style={{
                        backgroundColor: banner.backgroundColor,
                        backgroundImage: banner.backgroundImage?.paths?.length ? `url(${getFilePath(renderSourceBaseOfDevice(banner.backgroundImage.paths))})` : "",
                        height: `${width > small ? banner.backgroundLargeHeight : banner.backgroundSmallHeight}px`,
                    }}
                    className={`top-side-banner-item ${banner.link?.url && !banner.link.text ? "cursor-pointer" : ""}`}
                    onClick={() => banner.link?.url && push(banner.link.url)}
                >
                    <div className="banner-content flex flex-center justify-between">
                        <div className="flex flex-center flex-grow">
                            {
                                banner.icon ? <Icon name={`icon-${banner.icon}`} color="blue" />
                                    : ""
                            }
                            {
                                banner.text ? <div className="flex-grow" dangerouslySetInnerHTML={{ __html: banner.text.html }} />
                                    : ""
                            }
                        </div>
                        {
                            banner.link?.text ? <div className={`banner-link ${banner.closable ? " has-close-btn" : ""}`}>
                                <Button
                                    width="auto"
                                    color="white"
                                    height="30px"
                                    text={banner.link.text}
                                    url={banner.link.url}
                                />
                            </div>
                                : ""
                        }
                        {
                            banner.closable ? <Button
                                rounded
                                className="close-btn"
                                icon="icon-close"
                                color="danger"
                                onClick={(ev) => { ev.stopPropagation(); onCloseButtonClick(banner.contentItemId!) }}
                            />
                                : ""
                        }
                    </div>
                </div>
                {
                    index !== dataSource.length - 1 ? <Divider varient="border" mode="default" orientation="horizontal" />
                        : ""
                }
            </Fragment>
        )
    })
    return (
        <div
            className="top-side-banner"
            id={id || "topSideBanner"} >
            {topSideBannerItems}
        </div>
    )
}

export default TopSideBanner;